export default __webpack_public_path__ + "static/media/user.2fda6558.png";